<template>
	<div class="main">
		<!-- <v-alert
			icon="mdi-alert"
			color="info"
			elevation="4"
			dark
			class="mb-8 rounded-lg"
		>
			<b>Este sitio web se encuentra en construcción.</b>
		</v-alert> -->
		<hero
			class="hero"
			image
			@install-app="$emit('install-app')"
			:deferredPrompt="deferredPrompt"
		>
		</hero>

		<v-alert
			elevation="2"
			class="mt-8 mb-0 rounded-lg"
			colored-border
			color="success"
			border="left"
		>
			<span>
				<b
					>¿Necesitas ayuda? Puedes consultar a continuación nuestro
					vídeo de ayuda:</b
				><v-btn
					color="success"
					href="https://youtu.be/xjsoNG0Raio"
					class="rounded-xl"
					text
					target="_blank"
					>¿Cómo funciona Carreras Kinesia?</v-btn
				>
			</span>
		</v-alert>

		<v-alert
			elevation="2"
			class="mt-8 mb-0 rounded-lg ios-install-prompt"
			v-if="iOSBanner"
			colored-border
			color="info"
			border="left"
			dismissible
		>
			<span
				>Para instalar la aplicación en iOS
				<v-img
					class="ios-icon"
					src="../../assets/ios_share.png"
					alt=""
				></v-img>
				<b> pulse en el icono de compartir </b>

				y a continuación pulse en&nbsp;
				<v-img
					class="ios-icon"
					src="../../assets/ios_a2hs.png"
					alt=""
				></v-img>
				<b> Añadir a Pantalla de Inicio</b>
			</span>
		</v-alert>

		<div class="main-content">
			<div class="left">
				<filter-card
					@filterChanged="filterChanged"
					:filter="filter"
					class="hide-desktop filter-card"
				></filter-card>

				<transition>
					<component
						:is="selectedComponent.value"
						:filter="filter"
						class="races-container"
						@snackbar-event="$emit('snackbar-event', $event)"
						@loading="$emit('loading', $event)"
						@change-component="changeComponent"
						:componentOptions="componentOptions"
						:selectedComponent="selectedComponent"
					></component>
				</transition>
			</div>
			<div class="right hide-mobile">
				<filter-card
					@filterChanged="filterChanged"
					:filter="filter"
					class="filter-card"
				></filter-card>
			</div>
		</div>
	</div>
</template>

<script>
//Components:
import Hero from "../../components/user/Hero";

import RacesContainer from "../../components/user/RacesContainer";
import CircuitsContainer from "../../components/user/CircuitsContainer";
import FilterCard from "../../components/user/Filter";

export default {
	name: "UserMain",
	components: {
		Hero,
		RacesContainer,
		CircuitsContainer,
		FilterCard,
	},

	props: {
		deferredPrompt: {
			type: Object,
			default: null,
		},
		iOSBanner: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			filter: {
				range: [0, 200],
				notStarted: true,
				finished: false,
				free: false,
			},

			componentOptions: [
				{ text: "Carreras", value: "RacesContainer" },
				{ text: "Circuitos", value: "CircuitsContainer" },
			],
			selectedComponent: { text: "Carreras", value: "RacesContainer" },
		};
	},
	methods: {
		filterChanged({ filter }) {
			this.filter = { ...filter };
		},
		changeComponent(e) {
			this.selectedComponent = e;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";

.main {
	max-width: 100%;
	padding: 2em 0.5em;
	display: flex;
	flex-direction: column;
	background-color: #f0f0f3;
	min-height: 100vh;

	.hero {
		width: 100%;
	}

	.ios-install-prompt {
		span {
			font-size: 1.1em;
			text-align: justify;
			line-height: 1.75em;
		}

		.ios-icon {
			display: inline-block;
			height: 1.3em;
			width: 1.3em;
			transform: translateY(4px);
		}
	}

	.left {
		width: 100%;
	}

	.main-content {
		display: flex;
		width: 100%;
	}

	@include desktop {
		padding: 2em;

		.left {
			width: 100%;
			flex: 8;
			min-width: 0;
		}

		.right {
			width: 100%;
			flex: 3;
			min-width: 0;
			margin-left: 2em;
		}
	}

	.filter-card {
		margin-top: 2em;
	}
	.small-cards-container {
		margin-top: 2em;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		@include desktop() {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
			column-gap: 2em;
		}

		.small-card {
			width: 100%;
		}
	}

	.races-container {
		margin-top: 2em;
		margin-bottom: 2em;
	}
}
</style>
